// extracted by mini-css-extract-plugin
export default {"root":"FormLayout_root__ibs1D","headerWrapper":"FormLayout_headerWrapper__-hRtW","subtitleWrapper":"FormLayout_subtitleWrapper__b2qZZ","form":"FormLayout_form__p4Nxd"};